export default "__VITE_ASSET__DTDs81fV__"